import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

interface Category {
  term_id: number;
  name: string;
  count: number;
  // optionally: slug, description, etc.
}

export default function BrowseSpecialty() {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(
          'https://therevulist.com/wp-json/directorist/v1/listings/categories?hide_empty=true'
        );
        const data = await res.json();

        // Map the response into your Category interface
        const cats = data.map((cat: any) => ({
          term_id: cat.term_id,
          name: cat.name,
          count: cat.count,
        }));

        setCategories(cats);
      } catch (err) {
        console.error('Error fetching Directorist categories', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  if (loading) {
    return <div className="text-center py-12">Loading specialties…</div>;
  }

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Browse by Specialty</h2>
          <p className="text-lg text-gray-600">Find the right care for your specific needs</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {categories.map((spec) => (
            <Link
              key={spec.term_id}
              to={`/vendors?category=${encodeURIComponent(spec.name)}`}
              className="group p-6 rounded-2xl border border-gray-100 hover:border-teal-100 bg-white hover:bg-teal-50 transition-all duration-300 text-center"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-teal-100 text-teal-600 flex items-center justify-center group-hover:bg-teal-600 group-hover:text-white transition-colors">
                {/* No icon mapping here, but you can map some manually if you want */}
                <i className="ri-folder-line text-2xl"></i>
              </div>
              <h3 className="font-semibold text-gray-900 mb-1">{spec.name}</h3>
              <span className="text-sm text-gray-500">{spec.count} providers</span>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/specialties"
            className="text-teal-600 font-medium hover:text-teal-700 flex items-center justify-center"
          >
            View all specialties <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
